import { CALL_PACKAGES_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = [];

export default function callPackages(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case CALL_PACKAGES_FETCHED:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
